import * as React from "react";

const IconNotificacao = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="80"
    fill="none"
    viewBox="0 0 77 80"
  >
    <path
      stroke="var(--color-057)"
      strokeWidth="1.217"
      d="M75.428 39.868c0 21.71-16.776 39.259-37.41 39.259S.608 61.577.608 39.867 17.384.609 38.018.609s37.41 17.55 37.41 39.26Z"
    ></path>
    <path
      fill="var(--color-057)"
      d="M38.016 20.412c-1.321 0-2.39 1.12-2.39 2.506v1.504c-5.45 1.159-9.558 6.218-9.558 12.279v1.472c0 3.68-1.292 7.236-3.622 9.992l-.552.65c-.628.736-.777 1.794-.396 2.694.38.9 1.24 1.48 2.18 1.48h28.676c.941 0 1.793-.58 2.181-1.48s.232-1.958-.396-2.694l-.552-.65c-2.33-2.756-3.622-6.304-3.622-9.992V36.7c0-6.061-4.108-11.12-9.559-12.28v-1.503c0-1.386-1.068-2.506-2.39-2.506m3.383 38.63a5.14 5.14 0 0 0 1.397-3.547h-9.559c0 1.331.5 2.608 1.396 3.548a4.67 4.67 0 0 0 3.383 1.464c1.27 0 2.487-.525 3.383-1.464"
    ></path>
  </svg>
);

export default IconNotificacao;
